export const NoWrap: React.FC<{children: React.ReactNode}> = ({ children }) => (
    <span style={{whiteSpace: 'nowrap'}}>{children}</span>
);
